<template>
  <main>
    <div class="configurator">
      <PreviewWindow />
      <ConfigWindow />
      <Controller />
    </div>
  </main>
</template>

<script>
import PreviewWindow from './components/PreviewWindow.vue';
import ConfigWindow from './components/ConfigWindow.vue';
import Controller from './components/Controller.vue';
import store from '@/store';
import { provide } from 'vue';
import { API_URL } from './config.js';

export default {
  name: 'App',
  setup() {
    provide('store', store);
  },
  components: {
    PreviewWindow,
    ConfigWindow,
    Controller
  },
  mounted() {

    fetch(store.state.optionsEndpoint)
    .then(result => {
        if (result.ok) {
            return result.json();
        }
        else {
            throw new Error("Error"); 
        }
    })
    .then(data => {
        // Setting up base data for configurator
        store.state.proceedButtonLink = data.acf.bookButtonPageID;
        store.state.optionsLoaded = true;
        store.state.pageTitle = data.acf.pageTitle;
        store.state.productPlaceholder = data.acf.placeholderImage.sizes.thumbnail;
        store.state.defaultLinjeImage = data.acf.defaultImage.sizes["full-hd-hard"];
        store.state.currentLinjeImage = data.acf.defaultImage.sizes["full-hd-hard"];
        store.state.sizes = data.acf.storlek;
        store.state.warningText = data.acf.warning;
        let steps = data.acf.step;
        let counter = 1;
        for (const step of steps) {
          if (step.active == true) {
            step.order = counter;
              counter++;
          }
        }
        store.state.numberOfSteps = counter -1;

        // Setting up local storage
        if (localStorage.hasOwnProperty('selection')) {
          let storageArray = JSON.parse(localStorage.selection);
          let creationTime = storageArray.creationTime;
          let currentTime = Math.floor(Date.now() / 1000);
          if (( currentTime - creationTime ) > parseInt(data.acf.localStorageLifetime)) {
            let storageArray = {};
            for (let stepNumber = 0; stepNumber < steps.length; stepNumber++) {
              if (steps[stepNumber].endpoint != "storlekar") {
                storageArray[steps[stepNumber].endpoint] = {};
                if (steps[stepNumber].productEndpoint) {
                  storageArray[steps[stepNumber].productEndpoint] = [];
                }
                if (steps[stepNumber].componentType == "tillval") {
                  storageArray[steps[stepNumber].endpoint] = [];
                }
              }
            }
            storageArray["creationTime"] = Math.floor(Date.now() / 1000);
            storageArray["storlek"] = 0;
            storageArray["pris"] = 0;
            localStorage.selection = JSON.stringify(storageArray);
          }
        } else {
           let storageArray = {};
            for (let stepNumber = 0; stepNumber < steps.length; stepNumber++) {
              if (steps[stepNumber].endpoint != "storlekar") {
                storageArray[steps[stepNumber].endpoint] = {};
                if (steps[stepNumber].productEndpoint) {
                  storageArray[steps[stepNumber].productEndpoint] = [{"id":184,"slug":"sten","linjer":[11],"displayName":"Sten","quantity":1,"permalink": API_URL + "/koksluckor/sten/"}];
                }
                if (steps[stepNumber].componentType == "tillval") {
                  storageArray[steps[stepNumber].endpoint] = [];
                }
              }
            }
            storageArray["creationTime"] = Math.floor(Date.now() / 1000);
            storageArray["storlek"] = 0;
            storageArray["pris"] = 0;
            localStorage.selection = JSON.stringify(storageArray);
        }

        while (!localStorage.hasOwnProperty('selection')) {
          console.log("Waiting for localstorage to be created.");
          setTimeout(() => {return true}, 100)
        };

        let storageArray2 = JSON.parse(localStorage.selection);
        if (storageArray2.linjer.hasOwnProperty('id')) {
          store.state.chosenLinje = storageArray2.linjer;

        }
        storageArray2["loadedInitialLinje"] = false;
        localStorage.selection = JSON.stringify(storageArray2);

        store.state.steps = steps;
        // console.log(storageArray2)
    })
    .catch(err => console.log(err.message + " when calling endpoint: " + state.endpoint + endpoint));
  }
}
</script>

<style lang="scss">
  // This comment needs to be here to load scss properly. (it can't be empty)
</style>
